import React from 'react';
import { profileStrings } from '@/constants/residents/marketplaceStrings';
import { MarketplaceEmptyState } from './MarketplaceEmptyState';

interface EmptyListingsStateProps {
  type: 'active' | 'sold';
}

/**
 * Empty state for My Listings tabs (active/sold)
 * Uses the generic MarketplaceEmptyState component
 */
export const EmptyListingsState: React.FC<EmptyListingsStateProps> = ({ type }) => {
  const title = type === 'sold' ? profileStrings.noItemsSold : profileStrings.noActiveListings;
  const subtitle = type === 'sold' 
    ? profileStrings.onceYouSell
    : profileStrings.postItemToStart;

  return (
    <MarketplaceEmptyState
      title={title}
      subtitle={subtitle}
      style={{ paddingVertical: 20 }}
    />
  );
};

